import React from 'react';

// ** components imports
import NormalButton from '../../../common/Buttons/NormalButton';

// ** enums imports
import { BUTTON_THEMES } from '../../../../enums/common';

const NoQuizData = ({ handleEditQuiz }) => {
  return (
    <section className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
      <div className="px-4 py-4 sm:px-6 sm:py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-violet-100 dark:bg-violet-900/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg
                className="w-5 h-5 text-violet-600 dark:text-violet-400"
                fill="none"
                viewBox="0 0 24 24"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"></path>
                </svg>
              </svg>
            </div>
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-gray-100">
                Quiz Response Section
              </h2>
              <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                No quiz data available
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 sm:p-6 flex items-center justify-center min-h-[150px] sm:min-h-[200px]">
        <div className="text-center">
          <svg
            className="w-10 h-10 sm:w-12 sm:h-12 text-gray-400 dark:text-gray-500 mx-auto mb-3 sm:mb-4"
            fill="none"
            viewBox="0 0 24 24"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"></path>
            </svg>
          </svg>
          <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400">
            No quiz response data found for this tax file
          </p>
        </div>
      </div>
    </section>
  );
};

export default NoQuizData;
